import moment from 'moment/moment';

export default class OfferingAppointment {
    static fromData(data) {
        if (!data) {
            return;
        }

        const appointment = new OfferingAppointment();
        if (data.appointmentSeries) {
            appointment.appointmentSeries = {
                id: data.appointmentSeries.id || null,
                interval: data.appointmentSeries.interval,
            };
            appointment.id = data.appointmentSeries.id || null;
            appointment.interval = data.appointmentSeries.interval;
        }
        appointment.start = data.start || null;
        appointment.end = data.end || null;
        appointment.hasAppointmentOverride = data.hasAppointmentOverride;
        appointment.appointmentOverride = {
            instructors: [],
            fields: [],
        };
        if (data.appointmentOverride) {
            data.appointmentOverride.instructors.forEach((instructor) => appointment.appointmentOverride.instructors.push(
                {
                    value: instructor.id,
                    label: instructor.fullName,
                },
            ));
            appointment.appointmentOverride.note = data.appointmentOverride.note;
            appointment.appointmentOverride.title = data.appointmentOverride.title;
            appointment.appointmentOverride.isCanceled = data.appointmentOverride.isCanceled;
            appointment.appointmentOverride.fields = data.appointmentOverride.fields;
        }
        appointment.instructors = data.instructors;
        if (data.offering) {
            appointment.offeringTitle = data.offering.title;
            appointment.offeringId = data.offering.id || null;
            appointment.backgroundColor = data.offering.offeringCategory.backgroundColor;
            appointment.offeringCategory = data.offering.offeringCategory.name;
        }
        appointment.weekday = data.weekday;
        appointment.acceptedCount = data.acceptedCount;
        appointment.bookingCount = data.bookingCount;
        appointment.rejectedCount = data.rejectedCount;
        appointment.unsureCount = data.unsureCount;
        appointment.attendancePresentCount = data.attendancePresentCount;
        appointment.attendanceAbsentCount = data.attendanceAbsentCount;
        appointment.attendanceNoneCount = data.attendanceNoneCount;
        appointment.waitListCount = data.waitListCount;
        appointment.canEdit = data.canEdit;
        appointment.canCancel = data.canCancel;

        appointment.key = `${appointment.id}_${moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmm')}`;

        return appointment;
    }

    equals(appointment) {
        if (appointment.id === null) {
            return false;
        }
        return appointment.id === this.id;
    }
}
